module.exports = __webpack_public_path__ + "static/media/freenzy.8ca21db7.png";